import styled, { css } from 'styled-components';
import { Colors, Media, MenuSizes } from 'enums';

export const HeaderWrapper = styled.div`
  display: flex;
  flex: 1;
  gap: 24px;
`;

export const FocusContentStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  @media ${Media.notebook} {
    display: none;
  }
`;

export const SecondaryMenuContainer = styled.div`
  display: flex;
`;

export const SearchRequestWrap = styled.div<{ isSideBarOpen?: boolean }>`
  display: flex;
  justify-content: space-between;
  position: relative;

  & div {
    @media ${Media.mobile} {
      order: 1;

      margin-left: -220px;

      ${({ isSideBarOpen }) =>
        isSideBarOpen &&
        css`
          margin-left: 0;
        `}
    }
    @media ${Media.tablet} {
      order: 0;
      margin-left: 0;
    }
  }

  @media ${Media.mobile} {
    min-width: 245px;
    gap: 20px;

    ${({ isSideBarOpen }) =>
      isSideBarOpen &&
      css`
        width: 100%;
      `}
  }

  @media ${Media.tablet} {
    gap: 0;

    ${({ isSideBarOpen }) =>
      isSideBarOpen &&
      css`
        width: auto;
      `}
  }

  @media ${Media.desktop} {
    gap: 50px;
  }

  & button {
    width: 320px;
    height: 56px;
    z-index: 10;

    @media ${Media.mobile} {
      width: 180px;
      height: 48px;
      order: 0;
    }

    @media ${Media.tablet} {
      order: 1;
      margin-right: 20px;
    }

    @media ${Media.notebook} {
      width: 240px;
      height: 56px;
    }

    @media ${Media.desktop} {
      width: 320px;
      height: 56px;
    }
  }
`;

export const LogoWrapper = styled.div`
  flex: none;
  margin-right: 78px;

  @media ${Media.notebook} {
    width: ${MenuSizes.notebook.width};
  }
  @media ${Media.desktop} {
    width: ${MenuSizes.desktop.width};
    margin-right: 120px;
  }
`;

export const AvatarWrapper = styled.div`
  position: relative;
`;

export const NotificationBubble = styled.div`
  position: absolute;
  height: 10px;
  width: 10px;
  border-radius: 99px;
  border: 1px solid ${Colors.white};
  left: 0px;
  top: 0px;
  background-color: ${Colors.yellow1};
`;
